import type { ExperimentStatus, ThresholdState } from '../../netlify/functions/_lib/domain.ts';

const THRESHOLD: Record<ThresholdState, { word: string; className: string }> = {
  threshold_reached: { word: 'Threshold reached', className: 'bg-met-soft text-met' },
  threshold_not_reached: { word: 'Threshold not reached', className: 'bg-surface-sunk text-ink-muted' },
  pending: { word: 'Too early', className: 'bg-pending-soft text-pending' },
};

const STATUS: Record<ExperimentStatus, string> = {
  draft: 'Draft',
  running: 'Running',
  decided: 'Decided',
  archived: 'Archived',
};

export function ThresholdWord({ state }: { state: ThresholdState }) {
  const t = THRESHOLD[state];
  return (
    <span className={`inline-block rounded px-2 py-0.5 text-sm ${t.className}`}>{t.word}</span>
  );
}

export function ExperimentStatusWord({ status }: { status: ExperimentStatus }) {
  return <span className="text-sm text-ink-muted">{STATUS[status]}</span>;
}
